import { has as _has } from "lodash-es";
import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { Formik, Form } from "formik";
import * as yup from "yup";

import { registerUser } from "../actions/user";
import { fetchUpdates } from "../actions/sync";
import { getPostAuthRedirectPath } from "../utils";

import Loading from "../components/Loading";
import LabeledFormField from "../components/LabeledFormField";
import Button from "../components/Button";

const mapDispatchToProps = (dispatch) => ({
  registerUser: (email, password, passwordConfirm) =>
    dispatch(registerUser(email, password, passwordConfirm)),
  fetchUpdates: () => dispatch(fetchUpdates()),
});

export function Register(props) {
  const history = useHistory();
  const [showLoader, setShowLoader] = useState(false);

  const validationSchema = yup.object().shape({
    email: yup.string().required("Email is required"),
    password: yup.string().required("Password is required"),
    passwordConfirm: yup.string().required("Confrim Password is required"),
  });

  function onSubmit({ email, password, passwordConfirm }, actions) {
    setShowLoader(true);

    props.registerUser(email, password, passwordConfirm).then((action) => {
      if (action.error) {
        const { response } = action.error.response.data;
        setShowLoader(false);
        if (_has(response, "errors")) {
          actions.setErrors({
            password: response.errors.password,
            email: response.errors.email,
            passwordConfirm: response.errors.passwordConfirm,
          });
          actions.setSubmitting(false);
        }
        return;
      }
      props.fetchUpdates().then((action) => {
        history.push(getPostAuthRedirectPath());
      });
    });
  }

  return (
    <div className="w-full px-4 sm:px-6 lg:px-8 mt-3">
      <div className="max-w-md mx-auto">
        <h1 className="text-2xl mb-3">Create an account</h1>
        <Formik
          initialValues={{
            email: "",
            password: "",
            passwordConfirm: "",
          }}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          validate={(values) => {
            const errors = {};
            if (
              values.passwordConfirm &&
              values.passwordConfirm !== values.password
            ) {
              errors.passwordConfirm = "Password mismatch";
            }
            return errors;
          }}
        >
          {({ isSubmitting }) => (
            <Form>
              <LabeledFormField
                label="Email"
                type="text"
                name="email"
                tabIndex="1"
              />
              <LabeledFormField
                label="Password"
                type="password"
                name="password"
                tabIndex="1"
              />
              <LabeledFormField
                label="Confirm Password"
                type="password"
                name="passwordConfirm"
                tabIndex="1"
              />
              <div>
                <Button
                  className="mt-4"
                  type="submit"
                  disabled={isSubmitting || showLoader}
                >
                  Create Account
                  {showLoader && (
                    <div className="text-center ml-1 relative top-0.5">
                      <Loading />
                    </div>
                  )}
                </Button>
                &nbsp; or &nbsp;
                <Link to="/sign-in">
                  <Button type="button" intent="nooutline">
                    Sign in
                  </Button>
                </Link>
              </div>
              <div className="mt-4">
                <Link
                  className="text-blue-700 hover:text-blue-900"
                  to="/reset-password"
                >
                  Forgot your password?
                </Link>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

Register.propTypes = {
  registerUser: PropTypes.func.isRequired,
  fetchUpdates: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(Register);
